/**
 * Hook for handling generic redirect actions
 */
import { useCallback } from 'react';
export function useRedirectAction({ setIsLoading, hookOptionsRef }) {
    const handleRedirect = useCallback(async (payment, actionData, options = {}) => {
        // For redirect type, let funnel orchestrator handle navigation via callbacks
        // Only auto-redirect if explicitly enabled (disableAutoRedirect: false)
        const shouldAutoRedirect = options.disableAutoRedirect === false;
        if (shouldAutoRedirect && actionData.metadata?.redirect?.redirectUrl) {
            window.location.href = actionData.metadata.redirect.redirectUrl;
        }
        else if (payment.status === 'succeeded') {
            // Payment succeeded - call success callbacks for funnel navigation
            setIsLoading(false);
            const response = {
                paymentId: payment.id,
                payment,
                order: payment.order,
            };
            // Hook-level callback (universal handler)
            if (hookOptionsRef.current?.onPaymentCompleted) {
                await hookOptionsRef.current.onPaymentCompleted(payment, {
                    isRedirectReturn: false,
                    order: response.order,
                });
            }
            // Legacy callback (backwards compatibility)
            options.onSuccess?.(response);
            // Funnel-aligned callback (recommended)
            options.onPaymentSuccess?.(response);
        }
    }, [setIsLoading, hookOptionsRef]);
    return { handleRedirect };
}
